import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbles"><Path fillRule="evenodd" clipRule="evenodd" d="M6.00195 3H22.002V15H18.002V19H10.7611L5.00195 22.1995V19H2.00195V7H6.00195V3ZM8.00195 7H18.002V13H20.002V5H8.00195V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbles;
